var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzAssessmentBuilderHumanReviewShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz assessment builder human review shield") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "#0A1D38",
    stroke: "#2D5278"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 12 41 18v10c0 9-5 15-13 19-8-4-13-10-13-19V18l13-6Z",
    fill: "none",
    stroke: "#80C4FF",
    strokeWidth: 2.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21 29 5 5 10-12",
    fill: "none",
    stroke: "#FF85B2",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzAssessmentBuilderHumanReviewShield);
export default __webpack_public_path__ + "static/media/talentlenz-assessment-builder-human-review-shield.f4feb38c3384624250034d3f8e3ea9e7.svg";
export { ForwardRef as ReactComponent };